import styled from 'styled-components';

interface openProps {
  $isopen: boolean;
}

export const SideContainer = styled.nav<openProps>`
  background-color: #FFDA82;
  height: calc(100% - 20px);
  opacity: ${({ $isopen: isOpen }) => (!isOpen ? '0' : '1')};
  left: ${({ $isopen: isOpen }) => (!isOpen ? '-330px' : '20px')};
  max-height: 100vh;
  z-index: 2;
  top: 20px;
  flex-direction: column;
  max-width: 18.75rem;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  padding: 6px 0;
  min-height: 500px;
  position: ${({ $isopen: isOpen }) => (!isOpen ? 'absolute' : 'fixed')};

  @media (max-width: 1200px){
    top: 20px;
    right: auto;
    left: ${({ $isopen: isOpen }) => (!isOpen ? '-330px' : '0')};
  }

  @media (max-width: 835px){
    max-width: 100%;
    left: ${({ $isopen: isOpen }) => (isOpen ? '0' : '-100%')};
    height: 100%;
    top: 0;
  }

  &.active {
    @media (max-width: 835px) {
      width: 100%;
    }
  }

  &.active ~ div {
    @media (min-width: 835px) and (max-width: 1440px) {
      min-width: 445px;
      max-width: 1000px;
      width: 100%;
      margin-left: 320px;
      margin-top: 0;
    }
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 0 auto;
  padding: 16px 0;
  padding-top: 0;
  margin-bottom: 10px;

  .Sequencias{
    width: 100%;
    border-bottom: 1px solid #3D3D3D;
    border-top: 1px solid #3D3D3D;
    color: #3D3D3D;
    padding: 16px;
    font-size: 19px;
    font-family: "Museo";
    font-weight: 500;
    margin-bottom: 10px;
  }
`;

export const OpenSide = styled.div<openProps>`
  display: flex;
  margin-left: 1.5rem;
  font-size: 2rem;
  background: none;
  height: 55px;
  justify-content: start;
  align-items: center;

  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  background-color: #FBFBFB;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  width: 1.7em;
  height: 1.5em;
  padding: 16px;
  margin-top: .5em;

  @media (min-width: 1501px){
    position: fixed;
    top: 1em;
  }

  @media (max-width: 900px){
    position: absolute;
    left: 20px;
    z-index: 3;
    margin: 0;
  }

  svg {
    font-size: 1em;
  }
`;

export const CloseSide = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
  color: #3D3D3D;
  font-family: "Museo", sans-serif;
  margin: 10px;

  svg {
    cursor: pointer;
    color: #3D3D3D;
    margin-left: auto;
  }
`;
